import { render, staticRenderFns } from "./OrganisationUserForm.vue?vue&type=template&id=62801857&scoped=true"
import script from "./OrganisationUserForm.vue?vue&type=script&lang=js"
export * from "./OrganisationUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62801857",
  null
  
)

export default component.exports